module.exports = __webpack_public_path__ + "static/media/NotasFiscais9.3eadd9c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais9.png
// module id = 2140
// module chunks = 0